module.exports = __webpack_public_path__ + "img/profile2.fa667af2.png";